module.exports = __webpack_public_path__ + "img/490a.e7a14d6a.png";